export const handleAlphaError = (isError, error, prop) => {
    if(isError && error?.hasOwnProperty(prop)){
        return JSON.stringify(error?.data)
    }else {
        return JSON.stringify(error?.error)
    }
}